import { useQueryClient } from "@tanstack/react-query";
import { useInterpret } from "@xstate/react";
import { useRouter } from "next/router";
import { createContext } from "react";
import { toast } from "react-toastify";
import { InterpreterFrom } from "xstate";

import { useTranslation } from "../core/translation.core";
import { checkoutMachine } from "./checkout.state";
import { useOnlineCheckoutState } from "./onlineCheckoutState.hooks";
import { onlineCheckoutMachine } from "./online-checkout.state";

// Ref: https://stately.ai/blog/how-to-manage-global-state-with-xstate-and-react

interface RootStateType {
  checkoutService: InterpreterFrom<typeof checkoutMachine>;
  onlineCheckoutService: InterpreterFrom<typeof onlineCheckoutMachine>;
}

export const RootStateContext = createContext({} as RootStateType);

export const GlobalStateProvider = (props) => {
  const router = useRouter();
  const { t, msg } = useTranslation();
  const queryClient = useQueryClient();

  const onlineCheckoutService = useOnlineCheckoutState();
  const checkoutService = useInterpret(checkoutMachine, {
    actions: {
      pushPaymentCompleted: (_, event) => {
        queryClient.invalidateQueries();
        router.push(`/historyList/${event.orderId}`);
        queryClient.invalidateQueries({ queryKey: ["posOrders"] });
        queryClient.invalidateQueries({ queryKey: ["order"] });
        toast.success(t(msg.order.success));
      },
    },
  });

  return (
    <RootStateContext.Provider
      value={{
        checkoutService,
        onlineCheckoutService,
      }}
    >
      {props.children}
    </RootStateContext.Provider>
  );
};
